import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "../app/globals.css";
import TerraBoaRoot from "../app/terra-boa-root";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TerraBoaRoot />
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}
